import { pairingFeature } from '../../../../features/pairing/contract'
import { checkACK } from '../../capabilities/memory'
import { CMD_VT_CH584, PROTOCOL_CONFIG_VT_CH584 } from '../../protocols/cmd'

const REPORT_ID = PROTOCOL_CONFIG_VT_CH584.report_id
const FEATURE_REPORT_ID = PROTOCOL_CONFIG_VT_CH584.feature_report_id
export class VTCH584Pairing extends pairingFeature {
  // 开始配对
  public async start(): Promise<boolean> {
    // 1.切换工作模式
    await this.switchMode(0x81)
    // 2.清除配对状态
    await this.clearPairing()
    // 3.写入RF
    await this.writeRF()
    // 4.循环读取结果
    return await this.readResult()
  }

  // ============== 私有协议方法 ==============

  // 切换工作模式
  private async switchMode(mode: number): Promise<void> {
    console.log('[VTCH584Pairing] switch mode')
    const cmd = CMD_VT_CH584.switch_work_mode[0]
    const payload = new Uint8Array([cmd, mode])

    const res = await this.device.sendAndWait(REPORT_ID, payload, FEATURE_REPORT_ID, (res) => {
      const ack = res.getUint8(0)
      return ack !== 0x02
    })

    checkACK(res)
  }

  // 写入RF
  private async writeRF(): Promise<void> {
    console.log('[VTCH584Pairing] write rf')
    const RFAddress = this.generateRFAddress()
    console.log('RFAddress', RFAddress)
    const cmd = CMD_VT_CH584.code_match_mode
    const payload = new Uint8Array([...cmd, ...RFAddress])

    const res = await this.device.sendAndWait(REPORT_ID, payload, FEATURE_REPORT_ID, (res) => {
      const ack = res.getUint8(0)
      return ack !== 0x02
    })

    checkACK(res)
  }
  private generateRFAddress() {
    const a = Math.floor(Math.random() * 256) // 生成0到255之间的随机数作为RF地址
    const b = Math.floor(Math.random() * 256) // 生成0到255之间的随机数作为RF地址
    const c = Math.floor(Math.random() * 256) // 生成0到255之间的随机数作为RF地址
    const d = Math.floor(Math.random() * 256) // 生成0到255之间的随机数作为RF地址
    return [a, b, c, d]
  }

  private async clearPairing(): Promise<void> {
    const cmd = CMD_VT_CH584.clear_code_status
    const payload = new Uint8Array([...cmd])

    const res = await this.device.sendAndWait(REPORT_ID, payload, FEATURE_REPORT_ID, (res) => {
      const ack = res.getUint8(0)
      return ack !== 0x02
    })

    checkACK(res)
  }
  /**
   * 通过 device_pairing_status 指令查询配对状态
   * @returns true=配对成功, false=配对未完成, throw=指令失败
   */
  private async queryPairingStatus(): Promise<boolean> {
    const res = await this.device.sendAndWait(
      REPORT_ID,
      new Uint8Array(CMD_VT_CH584.device_pairing_status),
      FEATURE_REPORT_ID,
      (res) => res.getUint8(0) !== 0x02,
      { maxRetries: 10 },
    )
    checkACK(res)
    console.log(`query pairing status: ${res.getUint8(1)}`)
    return res.getUint8(1) === 0x01
  }

  /**
   * 通过 read_work_mode 指令判断配对状态（旧协议兜底）
   * @returns true=配对完成, false=配对未完成, throw=指令失败
   */
  private async queryWorkMode(): Promise<boolean> {
    const res = await this.device.sendAndWait(
      REPORT_ID,
      new Uint8Array([CMD_VT_CH584.read_work_mode[0]]),
      FEATURE_REPORT_ID,
      (res) => res.getUint8(0) !== 0x02,
      { maxRetries: 10 },
    )
    checkACK(res)
    console.log(`query work mode: ${res.getUint8(1)}`)
    // 工作模式回到 0x00 表示配对完成
    return res.getUint8(1) === 0x00
  }

  private async readResult(maxRetries = 200, intervalMs = 200): Promise<boolean> {
    console.log('[VTCH584Pairing] read result')

    for (let attempt = 0; attempt < maxRetries; attempt++) {
      console.log(`[VTCH584Pairing] attempt ${attempt + 1}`)

      // 方式1: 优先通过 device_pairing_status 查询
      try {
        const paired = await this.queryPairingStatus()
        if (paired) {
          console.log('[VTCH584Pairing] pairing success')
          return true
        }
      } catch {
        console.warn(
          `[VTCH584Pairing] attempt ${attempt + 1}: queryPairingStatus failed, fallback to queryWorkMode`,
        )
        try {
          // 方式1失败时，走方式2兜底（部分旧协议设备不支持方式1）
          // 方式2是软件端的主要判断方式，当前项目不使用该方式的原因是：新的master系列鼠标存在使用该方式无法正常获取到配对结果的情况
          // 虽然固件端不承认该方式，但软件端master系列鼠标依旧是可行的，只是走webHID不可行而已
          const paired = await this.queryWorkMode()
          if (paired) {
            console.log('[VTCH584Pairing] pairing success (by work mode)')
            return true
          }
        } catch {
          // 两种方式都报错 → 设备不支持这些指令（如未进入配对模式等），直接拒绝退出
          console.warn('[VTCH584Pairing] both query methods failed, aborting')
          return Promise.reject(
            new Error(
              'pairing query failed: both device_pairing_status and read_work_mode are unavailable',
            ),
          )
        }
      }

      // 未成功，等待 intervalMs 后再试
      await new Promise((r) => setTimeout(r, intervalMs))
    }

    console.warn('[VTCH584Pairing] pairing timeout')
    return false
  }
}
